import Icon from '../components/Icon.vue'

Icon.register({
  'assistive-listening-systems': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 260C216 275.5 203.5 288 188 288S160 275.5 160 260C160 215.9 195.9 180 240 180S320 215.9 320 260C320 275.5 307.5 288 292 288S264 275.5 264 260C264 246.8 253.2 236 240 236S216 246.8 216 260zM240 84C143 84 64 163 64 260 64 275.5 76.5 288 92 288S120 275.5 120 260C120 193.8 173.8 140 240 140S360 193.8 360 260C360 335.2 289 330.3 288 403.6L288 404C288 432.7 264.7 456 236 456 220.5 456 208 468.5 208 484S220.5 512 236 512C295.5 512 343.9 463.7 344 404.2 344.6 369.8 416 356 416 260 416 163 337 84 240 84zM160 320C142.3 320 128 334.3 128 352S142.3 384 160 384 192 369.7 192 352 177.7 320 160 320zM32 448C14.3 448 0 462.3 0 480S14.3 512 32 512 64 497.7 64 480 49.7 448 32 448zM512 260C512 258.5 512 257 512 255.5 510.1 140.5 436.2 38.5 328 1.5 313.4-3.5 297.4 4.3 292.4 19 287.4 33.6 295.3 49.5 309.9 54.5 395.8 83.9 454.5 165 456 256.5L456 256.6C456 257.8 456 258.9 456 260 456 275.5 468.5 288 484 288S512 275.5 512 260zM153 439L73 359 39 393 119 473 153 439z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/assistive-listening-systems.js
// module id = w6vC
// module chunks = 144